import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { QueryClientProvider, QueryClient } from "react-query";
import { CookiesProvider } from "react-cookie";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";

const Index = React.lazy(() => import("./app/Index"));

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            keepPreviousData: true,
            staleTime: 5000,
        },
    },
});

ReactDOM.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <CookiesProvider>
                <Suspense fallback={<span />}>
                    <Index />
                </Suspense>
            </CookiesProvider>
        </QueryClientProvider>
    </React.StrictMode>,
    document.getElementsByClassName("ek-chat")[0]
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
